import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { CheckCircle, ArrowRight } from "lucide-react";

export default function Complete() {
  const { member } = useAuth();
  const isActive = member?.status === "ACTIVE";
  const name = member?.preferred_name || member?.full_name || "";

  return (
    <div className="min-h-screen bg-lv-bg flex items-center justify-center px-6 py-12" data-testid="onboarding-complete">
      <div className="w-full max-w-md text-center">
        <div className="mb-10">
          <span className="font-serif text-2xl text-cream tracking-[0.25em]">LV PASS</span>
        </div>

        <CheckCircle size={48} className="text-lv-active mx-auto mb-6" />

        {isActive ? (
          <>
            <h1 className="font-serif text-2xl sm:text-3xl text-cream tracking-wide mb-4" data-testid="complete-heading">
              Your LV Pass is ready.
            </h1>
            <p className="text-sm text-sand/80 leading-relaxed mb-10">
              Welcome{name ? `, ${name}` : ""}. Your membership is active and your credential is ready to use.
            </p>
            <Link to="/pass" className="lv-btn-primary inline-flex items-center gap-3 min-h-[48px] px-8" data-testid="complete-view-pass">
              View My Pass <ArrowRight size={16} />
            </Link>
          </>
        ) : (
          <>
            <h1 className="font-serif text-2xl sm:text-3xl text-cream tracking-wide mb-4" data-testid="complete-heading">
              You're all set.
            </h1>
            <p className="text-sm text-sand/80 leading-relaxed mb-3">
              Thank you{name ? `, ${name}` : ""}. We've received your information and your LV Pass is now being prepared.
            </p>
            <div className="bg-walnut border border-lv-border p-5 text-left mb-10">
              <p className="text-xs tracking-[0.2em] uppercase text-lv-muted mb-3">What happens next?</p>
              <p className="text-sm text-sand/80 leading-relaxed">
                Your membership information will be reviewed and your Pass activated.
                There's nothing else you need to do right now. Once activated, you'll be able
                to access your digital LV Pass, QR credential and member privileges.
              </p>
              <p className="text-sm text-bronze mt-4 tracking-wide">
                We'll let you know when your Pass is ready.
              </p>
            </div>
            <p className="text-sm text-lv-muted italic tracking-wide">
              One Community. Belonging, wherever the game takes&nbsp;you.
            </p>
            <Link to="/pass" className="lv-btn-secondary inline-flex items-center gap-3 min-h-[44px] px-8 mt-8" data-testid="complete-go-to-pass">
              Go to My Pass
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
